(function () {
	'use strict';
	$(document).ready(function () {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const number = $(entry.target);
					if (!number.hasClass('counted')) {
						let numberText = number.text();
						number.empty();
						number.shuffleLetters({
							"text": numberText,
							"fps": 16,
							"step": 12
						})
						number.addClass('counted');
					}
				}
			});
		});

		const elements = document.querySelectorAll('.home .big-numbers .number');

		elements.forEach(element => {
			observer.observe(element);
		});
	});
}(jQuery));
